jQuery_T4NT(document).ready(function ($) {
  $(".t4s-navigation > ul > li").hover(
    function () {
      $("main").addClass("drop-menu-open");
      unScroll();
    },
    function () {
      $("main").removeClass("drop-menu-open");
      removeUnScroll();
    }
  );
  //禁止滚动条滚动
  function unScroll() {
    var top = $(document).scrollTop();
    $(document).on("scroll.unable", function (e) {
      $(document).scrollTop(top);
    });
  }
  //移除禁止滚动条滚动
  function removeUnScroll() {
    $(document).unbind("scroll.unable");
  }
});
